import { c as _c } from "react/compiler-runtime";
import { ZIN_DISPLAY_KEY_REELS_VILLA_PAGE, ZIN_KEY } from "@website/accommodation-ui/constant";
import { HotelBTSCoverage } from "@website/accommodation-ui/hotel-bts-coverage";
import { HotelCalendar } from "@website/accommodation-ui/hotel-calendar";
import { HotelReserveBookingCard } from "@website/accommodation-ui/hotel-reserve-booking-card";
import { HotelReserveDetails } from "@website/accommodation-ui/hotel-reserve-details";
import { HotelShortVideos } from "@website/accommodation-ui/hotel-short-videos";
import { VillaReserveCancellationPolicy } from "@website/accommodation-ui/villa-reserve-cancellation-policies";
import { VillaSpaces } from "@website/accommodation-ui/villa-spaces";
import { VillaSpecifications } from "@website/accommodation-ui/villa-specifications";
import { VillaSimilarRoomsInform } from "@website/accommodation-ui/villa_similar-rooms_inform/villa_similar_rooms_inform";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { Breadcrumb } from "@website/ui/breadcrumb";
import { CollapsibleText } from "@website/ui/collapsible-text";
import { FabMenu } from "@website/ui/fab-menu";
import { getOrigin } from "@website/utils/channel/get-origin";
import { isChannel } from "@website/utils/channel/helpers";
import { Footer } from "@website/widget/footer";
import { Header } from "@website/widget/header";
import { ReserveCommentsLayout } from "@website/widget/reserve-comments-layout";
import { ReserveFacilities } from "@website/widget/reserve-facilities";
import { ReserveGallery } from "@website/widget/reserve-gallery";
import { ReserveHostPolicies } from "@website/widget/reserve-host-policies";
import { ReserveMap } from "@website/widget/reserve-map";
import { ReserveNearBy } from "@website/widget/reserve-nearby";
import { ReservePolicies } from "@website/widget/reserve-policies";
import { ReserveRate } from "@website/widget/reserve-rate";
import { NextPage } from "next";
import Head from "next/head";
import { useRouter } from "next/router";
import { FC } from "react";
import Custom404 from "../../[...gone].page";
import { useHotelPageDataTransform } from "./index.hook";
import { HotelPagePropertiesType } from "./index.types";
const RoomPageContent: FC<HotelPagePropertiesType> = properties => {
  const $ = _c(103);
  const router = useRouter();
  const {
    booking,
    hotelBreadcrumbsProps,
    hotelReserveFacilitiesProps,
    hotelReserveMapProps,
    gallery,
    hotelReserveDetailsProps,
    hotelReserveCancellationPoliciesProps,
    hotelReserveRateProps,
    hotelReserveCommentsProps,
    description,
    hotelReservePoliciesProps,
    hotelReserveHostPoliciesProps,
    calendarProps,
    hotelReserveBtsCoveragesProps,
    villaSpecifications,
    villaSimilarRoomsProps,
    hotelReserveNearByProps,
    villaSpaces,
    isAnyPolicyExist
  } = useHotelPageDataTransform(properties);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      title: "\u062A\u0635\u0627\u0648\u06CC\u0631 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647",
      selector: "#hotel_gallery"
    };
    t1 = {
      title: "\u0645\u0634\u062E\u0635\u0627\u062A",
      selector: "#hotel_specifications"
    };
    t2 = {
      title: "\u0627\u0645\u06A9\u0627\u0646\u0627\u062A",
      selector: "#hotel_facilities"
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== villaSpaces) {
    t3 = villaSpaces.length > 0 && villaSpaces?.every(_temp) ? [{
      title: "\u0641\u0636\u0627\u0647\u0627\u06CC \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647",
      selector: "#hotel_spaces"
    }] : [];
    $[3] = villaSpaces;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      title: "\u062A\u0642\u0648\u06CC\u0645",
      selector: "#hotel_calendar"
    };
    t5 = {
      title: "\u0642\u0648\u0627\u0646\u06CC\u0646",
      selector: "#hotel_policies"
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== hotelReserveCommentsProps?.comments?.length || $[8] !== hotelReserveCommentsProps?.rate?.rate) {
    t6 = hotelReserveCommentsProps?.rate?.rate || hotelReserveCommentsProps?.comments?.length > 0 ? [{
      title: "\u0627\u0645\u062A\u06CC\u0627\u0632 \u0648 \u0646\u0638\u0631\u0627\u062A",
      selector: "#hotel_comments"
    }] : [];
    $[7] = hotelReserveCommentsProps?.comments?.length;
    $[8] = hotelReserveCommentsProps?.rate?.rate;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== hotelReserveMapProps) {
    t7 = hotelReserveMapProps && hotelReserveMapProps?.circle?.lat !== 35.696814 && hotelReserveMapProps?.circle?.lng !== 51.3498186 ? [{
      title: "\u0645\u0648\u0642\u0639\u06CC\u062A",
      selector: "#hotel_location"
    }] : [];
    $[10] = hotelReserveMapProps;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t6 || $[14] !== t7) {
    t8 = [t0, t1, t2, ...t3, t4, t5, ...t6, ...t7];
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const fabItems = t8;
  const t9 = `${hotelReserveDetailsProps.hotelTitle} | اسنپ تریپ`;
  let t10;
  if ($[16] !== t9) {
    t10 = <title>{t9}</title>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== properties.roomInfo?.seo?.noIndex) {
    t11 = properties.roomInfo?.seo?.noIndex && <meta content="noindex,nofollow" name="robots" />;
    $[18] = properties.roomInfo?.seo?.noIndex;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = getOrigin();
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const t13 = `${t12}${process.env.NEXT_PUBLIC_BASE_PATHNAME}/room/${router.query?.roomId}`;
  let t14;
  if ($[21] !== t13) {
    t14 = <link rel="canonical" href={t13} />;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t14) {
    t15 = <Head>{t10}{t11}{t14}</Head>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Header title={"\u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647"} />;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = addEventToTracking?.bind(null, USER_TRACKING_EVENTS.VILLA_SPACES_SECTION_VIEWED, {
      product: "villa"
    });
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== fabItems) {
    t18 = <FabMenu items={fabItems} eventToTracking={t17} />;
    $[29] = fabItems;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== hotelBreadcrumbsProps) {
    t19 = <div className="hidden py-[22px] md:block"><Breadcrumb {...hotelBreadcrumbsProps} className="hidden lg:flex" /></div>;
    $[31] = hotelBreadcrumbsProps;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== gallery) {
    t20 = <ReserveGallery gallery={gallery} title={"\u06AF\u0627\u0644\u0631\u06CC \u062A\u0635\u0627\u0648\u06CC\u0631 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647"} />;
    $[33] = gallery;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== router.query?.roomId) {
    t21 = isChannel(["jek", "android"]) && <HotelShortVideos className="px-6 lg:m-0 lg:hidden" displayType="REELS" displayId={ZIN_DISPLAY_KEY_REELS_VILLA_PAGE} zinKey={ZIN_KEY} zinTags={`${router.query?.roomId}`} />;
    $[35] = router.query?.roomId;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t19 || $[38] !== t20 || $[39] !== t21) {
    t22 = <div className="px-0 md:px-[24px] xl:px-[calc((100%-1200px)/2)]">{t19}{t20}{t21}</div>;
    $[37] = t19;
    $[38] = t20;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== hotelReserveDetailsProps) {
    t23 = <HotelReserveDetails {...hotelReserveDetailsProps} />;
    $[41] = hotelReserveDetailsProps;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== villaSpecifications) {
    t24 = <VillaSpecifications villaSpecifications={villaSpecifications} />;
    $[43] = villaSpecifications;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== hotelReserveFacilitiesProps) {
    t25 = <ReserveFacilities {...hotelReserveFacilitiesProps} />;
    $[45] = hotelReserveFacilitiesProps;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== villaSimilarRoomsProps) {
    t26 = <VillaSimilarRoomsInform {...villaSimilarRoomsProps} />;
    $[47] = villaSimilarRoomsProps;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] !== hotelReserveBtsCoveragesProps) {
    t27 = <HotelBTSCoverage btsCoverage={hotelReserveBtsCoveragesProps} />;
    $[49] = hotelReserveBtsCoveragesProps;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== villaSpaces) {
    t28 = <VillaSpaces spaces={villaSpaces} />;
    $[51] = villaSpaces;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] !== description) {
    t29 = description && <div><h6 className="text-on-surface-high-emphasis text-headline-6 mb-5">اقامتگاه</h6><CollapsibleText ariaLabel="description" collapsedClassName="h-[50px]" content={<p className="whitespace-pre-wrap">{description}</p>} /></div>;
    $[53] = description;
    $[54] = t29;
  } else {
    t29 = $[54];
  }
  let t30;
  if ($[55] !== calendarProps) {
    t30 = <HotelCalendar {...calendarProps} showTitle={true} />;
    $[55] = calendarProps;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] !== hotelReservePoliciesProps) {
    t31 = <ReservePolicies {...hotelReservePoliciesProps} />;
    $[57] = hotelReservePoliciesProps;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] !== hotelReserveHostPoliciesProps) {
    t32 = <ReserveHostPolicies {...hotelReserveHostPoliciesProps} />;
    $[59] = hotelReserveHostPoliciesProps;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  let t33;
  if ($[61] !== hotelReserveCancellationPoliciesProps || $[62] !== isAnyPolicyExist) {
    t33 = isAnyPolicyExist ? <VillaReserveCancellationPolicy {...hotelReserveCancellationPoliciesProps} /> : null;
    $[61] = hotelReserveCancellationPoliciesProps;
    $[62] = isAnyPolicyExist;
    $[63] = t33;
  } else {
    t33 = $[63];
  }
  let t34;
  if ($[64] !== hotelReserveRateProps) {
    t34 = <ReserveRate {...hotelReserveRateProps} />;
    $[64] = hotelReserveRateProps;
    $[65] = t34;
  } else {
    t34 = $[65];
  }
  let t35;
  if ($[66] !== hotelReserveCommentsProps) {
    t35 = <ReserveCommentsLayout {...hotelReserveCommentsProps} />;
    $[66] = hotelReserveCommentsProps;
    $[67] = t35;
  } else {
    t35 = $[67];
  }
  let t36;
  if ($[68] !== t23 || $[69] !== t24 || $[70] !== t25 || $[71] !== t26 || $[72] !== t27 || $[73] !== t28 || $[74] !== t29 || $[75] !== t30 || $[76] !== t31 || $[77] !== t32 || $[78] !== t33 || $[79] !== t34 || $[80] !== t35) {
    t36 = <div className="col-span-2"><div className="flex flex-col gap-[56px]">{t23}{t24}{t25}{t26}{t27}{t28}{t29}{t30}{t31}{t32}{t33}{t34}{t35}</div></div>;
    $[68] = t23;
    $[69] = t24;
    $[70] = t25;
    $[71] = t26;
    $[72] = t27;
    $[73] = t28;
    $[74] = t29;
    $[75] = t30;
    $[76] = t31;
    $[77] = t32;
    $[78] = t33;
    $[79] = t34;
    $[80] = t35;
    $[81] = t36;
  } else {
    t36 = $[81];
  }
  let t37;
  if ($[82] !== booking) {
    t37 = <div className="top-14 z-[5] col-span-1 mt-6 h-fit lg:sticky"><HotelReserveBookingCard {...booking} /></div>;
    $[82] = booking;
    $[83] = t37;
  } else {
    t37 = $[83];
  }
  let t38;
  if ($[84] !== t36 || $[85] !== t37) {
    t38 = <div className="relative grid-cols-3 gap-6 lg:grid">{t36}{t37}</div>;
    $[84] = t36;
    $[85] = t37;
    $[86] = t38;
  } else {
    t38 = $[86];
  }
  let t39;
  if ($[87] !== hotelReserveMapProps) {
    t39 = hotelReserveMapProps && <ReserveMap {...hotelReserveMapProps} />;
    $[87] = hotelReserveMapProps;
    $[88] = t39;
  } else {
    t39 = $[88];
  }
  let t40;
  if ($[89] !== hotelReserveNearByProps) {
    t40 = hotelReserveNearByProps && <ReserveNearBy {...hotelReserveNearByProps} />;
    $[89] = hotelReserveNearByProps;
    $[90] = t40;
  } else {
    t40 = $[90];
  }
  let t41;
  if ($[91] !== t38 || $[92] !== t39 || $[93] !== t40) {
    t41 = <div className="px-[24px] pb-[90px] xl:px-[calc((100%-1200px)/2)]">{t38}{t39}{t40}</div>;
    $[91] = t38;
    $[92] = t39;
    $[93] = t40;
    $[94] = t41;
  } else {
    t41 = $[94];
  }
  let t42;
  if ($[95] !== t22 || $[96] !== t41) {
    t42 = <section><article className="relative flex flex-col">{t22}{t41}</article></section>;
    $[95] = t22;
    $[96] = t41;
    $[97] = t42;
  } else {
    t42 = $[97];
  }
  let t43;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Footer />;
    $[98] = t43;
  } else {
    t43 = $[98];
  }
  let t44;
  if ($[99] !== t15 || $[100] !== t18 || $[101] !== t42) {
    t44 = <>{t15}{t16}{t18}{t42}{t43}</>;
    $[99] = t15;
    $[100] = t18;
    $[101] = t42;
    $[102] = t44;
  } else {
    t44 = $[102];
  }
  return t44;
};
const Index: NextPage<HotelPagePropertiesType> = properties => {
  const $ = _c(3);
  if (!properties.roomInfo) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Custom404 />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] !== properties) {
    t0 = <RoomPageContent {...properties} />;
    $[1] = properties;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default Index;
export { getServerSideProps } from "./index.server";
function _temp(item) {
  return item?.amenitiesGroup?.length > 0;
}